<template>
  <div class="  w-full">
        <Card class="main-card h-full min-h-full ml-2">
          <template #content>  

          <div class="grid ">
            <div class="col-12">
              <div >
                <div class="grid">
                    <div class="col">  
                        <div class=" ">
                            <i class="pi pi-money-bill text-blue-500 text-lg mr-2"></i>
                            <span class="text-xl font-semibold">Order Value </span>
                        </div>

                        <div v-if="order?.po_value" class="text-2xl font-bold mt-8">{{ formatCurrency(order?.po_value) }} </div>
                        <Skeleton v-if="!order?.po_value" width="6rem" height="2rem"></Skeleton>
                        <!-- <div v-if="orderValue > 0" class="text-sm text-500 mb-3 font-medium" >{{ formatCurrency(orderValue) }}</div> -->
                    </div>
                    <div class="col flex justify-content-end">
                        <div >
                            <Chart
                                type="doughnut"
                                :data="chartDataOrderCompletion"
                                :options="chartOptions"
                                style="width:100%; max-height:140px;"
                            />
                        </div>
                    </div>
                </div>                                  
              </div>
            </div>
          </div>
          </template>
        </Card>

        <Card class="main-card h-full min-h-full mt-4 ml-2">
          <template #content>  

          <div class="grid mt-1">
            <div class="col-12">
              <div >
                <div class="grid">
                    <div class="col">  
                        <div class=" ">
                            <i class="pi pi-money-bill text-green-500 text-lg mr-1"></i>
                            <span class="text-xl font-semibold">Available for Billing </span>
                        </div>

                        <div v-if="order?.po_value" class="text-2xl font-bold mt-8">{{ formatCurrency(order?.po_value) }} </div>
                        <Skeleton v-if="!order?.po_value" width="6rem" height="2rem"></Skeleton>
                        <div v-if="order?.po_value > 0" class="text-sm text-500 mb-3 font-medium" >{{ formatCurrency(order?.po_value) }}</div>
                    </div>
                    <div class="col flex justify-content-end">
                        <div >
                            <Chart
                                type="doughnut"
                                :data="chartDataOrderCompletion"
                                :options="chartOptions"
                                style="width:100%; max-height:140px;"
                            />
                        </div>
                    </div>
                </div>                                  
              </div>
            </div>
          </div>
          </template>
        </Card>
  </div>
</template>

<script>
import Card from 'primevue/card';
import Chart from 'primevue/chart';
import Skeleton from 'primevue/skeleton';
import { useDeptPoStore } from '@/stores/deptPoStore';
import { orderAnalytics } from '@/services/api/v2/apis';

export default {
  components:{
    Card,
    Skeleton,
    Chart,

    },
    data(){
      return{
        order:null,
        chartDataOrderCompletion: {
          labels:['Pending to Bill', 'Billed Value'],
          datasets: [
            {
              // data:[123, 541],
              backgroundColor: ["#FF5130", "#22C55E"],
              hoverBackgroundColor: ["#E32700", "#16A34A"],
            },
          ],
        },
        chartOptions: {
          cutout: "70%",
          plugins: {
            legend: {
              display: true,
            },
          },
        },
      }
    },
    mounted(){
      const store = useDeptPoStore();
        store.loadData();
        setTimeout(() => {
          this.order = JSON.parse(store.data);          
        }, 50);

        this.fetchOrderAnalytics();
    },
    methods:{
      async fetchOrderAnalytics(){
        try {
          const res = await orderAnalytics(this.$route.params.id);
          this.chartDataOrderCompletion.datasets[0].data = [res.data.notBilled, res.data.billed];
        } catch (error) {
          this.showErrorToast(error.response.data);
          
        }
      },
      formatCurrency(value) {
          if (value == null || isNaN(value)) return '-';
          return value.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
      },
      showErrorToast(error){
          this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 2500 });
      },
    }
}
</script>

<style>

</style>